/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Colorlut_Enum, colorlut_EnumFromJSON, colorlut_EnumToJSON } from "./colorlut";
import {
  IsothermBlendingMode_Enum,
  isothermBlendingMode_EnumFromJSON,
  isothermBlendingMode_EnumToJSON,
} from "./isotherm_blending_mode";
import { IsothermColor_Enum, isothermColor_EnumFromJSON, isothermColor_EnumToJSON } from "./isotherm_color";
import {
  IsothermFillMode_Enum,
  isothermFillMode_EnumFromJSON,
  isothermFillMode_EnumToJSON,
} from "./isotherm_fill_mode";
import { IsothermType_Enum, isothermType_EnumFromJSON, isothermType_EnumToJSON } from "./isotherm_type";
import { Range } from "./range";

export const protobufPackage = "flir_boson_driver";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface IsothermSettings {
  type: IsothermType_Enum;
  rangeC: Range | undefined;
  cutoffC: number;
  fillMode: IsothermFillMode_Enum;
  blendMode: IsothermBlendingMode_Enum;
  color: IsothermColor_Enum;
  palette: Colorlut_Enum;
  enable: boolean;
}

function createBaseIsothermSettings(): IsothermSettings {
  return { type: 0, rangeC: undefined, cutoffC: 0, fillMode: 0, blendMode: 0, color: 0, palette: 0, enable: false };
}

export const IsothermSettings = {
  encode(message: IsothermSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.rangeC !== undefined) {
      Range.encode(message.rangeC, writer.uint32(18).fork()).ldelim();
    }
    if (message.cutoffC !== 0) {
      writer.uint32(29).float(message.cutoffC);
    }
    if (message.fillMode !== 0) {
      writer.uint32(64).int32(message.fillMode);
    }
    if (message.blendMode !== 0) {
      writer.uint32(32).int32(message.blendMode);
    }
    if (message.color !== 0) {
      writer.uint32(40).int32(message.color);
    }
    if (message.palette !== 0) {
      writer.uint32(56).int32(message.palette);
    }
    if (message.enable === true) {
      writer.uint32(48).bool(message.enable);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IsothermSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIsothermSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.rangeC = Range.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.cutoffC = reader.float();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.fillMode = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.blendMode = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.color = reader.int32() as any;
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.palette = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.enable = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IsothermSettings {
    return {
      type: isSet(object.type) ? isothermType_EnumFromJSON(object.type) : 0,
      rangeC: isSet(object.rangeC) ? Range.fromJSON(object.rangeC) : undefined,
      cutoffC: isSet(object.cutoffC) ? globalThis.Number(object.cutoffC) : 0,
      fillMode: isSet(object.fillMode) ? isothermFillMode_EnumFromJSON(object.fillMode) : 0,
      blendMode: isSet(object.blendMode) ? isothermBlendingMode_EnumFromJSON(object.blendMode) : 0,
      color: isSet(object.color) ? isothermColor_EnumFromJSON(object.color) : 0,
      palette: isSet(object.palette) ? colorlut_EnumFromJSON(object.palette) : 0,
      enable: isSet(object.enable) ? globalThis.Boolean(object.enable) : false,
    };
  },

  toJSON(message: IsothermSettings): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = isothermType_EnumToJSON(message.type);
    }
    if (message.rangeC !== undefined) {
      obj.rangeC = Range.toJSON(message.rangeC);
    }
    if (message.cutoffC !== 0) {
      obj.cutoffC = message.cutoffC;
    }
    if (message.fillMode !== 0) {
      obj.fillMode = isothermFillMode_EnumToJSON(message.fillMode);
    }
    if (message.blendMode !== 0) {
      obj.blendMode = isothermBlendingMode_EnumToJSON(message.blendMode);
    }
    if (message.color !== 0) {
      obj.color = isothermColor_EnumToJSON(message.color);
    }
    if (message.palette !== 0) {
      obj.palette = colorlut_EnumToJSON(message.palette);
    }
    if (message.enable === true) {
      obj.enable = message.enable;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<IsothermSettings>, I>>(base?: I): IsothermSettings {
    return IsothermSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<IsothermSettings>, I>>(object: I): IsothermSettings {
    const message = createBaseIsothermSettings();
    message.type = object.type ?? 0;
    message.rangeC = (object.rangeC !== undefined && object.rangeC !== null)
      ? Range.fromPartial(object.rangeC)
      : undefined;
    message.cutoffC = object.cutoffC ?? 0;
    message.fillMode = object.fillMode ?? 0;
    message.blendMode = object.blendMode ?? 0;
    message.color = object.color ?? 0;
    message.palette = object.palette ?? 0;
    message.enable = object.enable ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
